import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routers from './router/index.js'
// 删掉多余的 VueMap 引入 ↓
// import VueMap from 'vue-amap'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import global from './global.css'
import axios from 'axios'
// 删掉多余的 vueConf 引入（vue.config.js 不需要use） ↓
// import vueConf from '../vue.config.js'

// element 内置交互特效引入
import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
//引入 图表插件
import * as echarts from 'echarts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/grid'

Vue.prototype.$request = axios
Vue.prototype.$Message = ElementUI.Message
Vue.prototype.$confirm = ElementUI.MessageBox
Vue.prototype.$echarts = echarts
axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.config.productionTip = false

const setFavicon = () => {
  const faviconHref = `${process.env.BASE_URL || '/'}favicon.svg?v=20260701`;
  const relList = ['icon', 'shortcut icon'];
  relList.forEach(rel => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement('link');
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.type = 'image/svg+xml';
    link.href = faviconHref;
  });
};

setFavicon();

// 修正1：路由插件使用错误 → 改用 Vue.use(VueRouter)
Vue.use(VueRouter)
// 删掉多余的 vueConf use ↓
// Vue.use(vueConf)

// #app 使用 transform 缩放时，遮罩挂到 body 会覆盖仍在 #app 内的弹窗并拦截首次点击。
// 统一让 el-dialog 的遮罩跟随弹窗本体挂载；个别弹窗仍可显式传入 true 覆盖此默认值。
ElementUI.Dialog.props.modalAppendToBody.default = false
Vue.use(ElementUI)
Vue.component(CollapseTransition.name, CollapseTransition)
// 删掉多余的 VueMap use ↓
// Vue.use(VueMap)

// 复制黏贴
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 高德地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);

// 从环境变量读取安全码，在地图 SDK 加载前设置
window._AMapSecurityConfig = {
  securityJsCode: process.env.VUE_APP_AMAP_SECURITY_JS_CODE,
};

// 从环境变量读取地图 key
VueAMap.initAMapApiLoader({
  key: process.env.VUE_APP_AMAP_MAP_KEY,
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType',
   'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Weather','AMap.Geocoder'],
  v: '1.4.4' // 保留你原始的1.4.4版本，不用改2.0
}) 

const router = new VueRouter({
	mode: 'history',
  routes: routers
})

router.beforeEach((to, from, next) => {
  const adminOnly = to.matched.some(record => record.meta && record.meta.adminOnly);
  if (adminOnly && Number(localStorage.getItem('a-xny-level')) !== 1) {
    next({ name: 'indexVue' });
    return;
  }
  next();
})

// http 请求拦截
axios.interceptors.request.use(config => {
    let token = localStorage.getItem("a-xny-token");
	if (token) {
	   config.headers['Token'] = token;
	}
	return config;
})

// http响应拦截
let isHandlingLoginExpired = false;

const redirectToLoginIfExpired = response => {
  if (response && response.data && Number(response.data.code) === 100001) {
    const isPublicRoute = router.currentRoute.matched.some(routeRecord => {
      return routeRecord.meta && routeRecord.meta.public;
    });
    if (isPublicRoute) {
      return false;
    }
    localStorage.removeItem('a-xny-token');
    if (!isHandlingLoginExpired && router.currentRoute.path !== '/login') {
      isHandlingLoginExpired = true;
      ElementUI.Message.warning(response.data.message || '登录状态已失效');
      router.replace('/login').then(() => {
        isHandlingLoginExpired = false;
      }, () => {
        isHandlingLoginExpired = false;
      });
    }
    return true;
  }
  return false;
}

axios.interceptors.response.use(response => {
  if (redirectToLoginIfExpired(response)) {
    // 登录失效已统一处理，不再触发业务页面的 then/catch 错误提示
    return new Promise(() => {});
  }
  return response;
}, error => {
  if (redirectToLoginIfExpired(error && error.response)) {
    return new Promise(() => {});
  }
  return Promise.reject(error);
})

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
// .$mount('#app')
